import axiosInstance from "../../../helpers/api";

export const getOfficeHours = () => {
  return axiosInstance.get("/admin/office_hours");
};

export const createOfficeHour = (body) => {
  return axiosInstance.post("/admin/office_hours", body);
};

export const updateOfficeHour = ({ id, body }) => {
  return axiosInstance.put(`/admin/office_hours/${id}`, body);
};

export const deleteOfficeHour = (id) => {
  return axiosInstance.delete(`/admin/office_hours/${id}`);
};
